import React, { useState } from 'react';
import { Input, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';
import { datalayer } from '../../utils/appWrapper';
import withFormsyValidations from '../withFormsyValidations';

interface RestaurantNumberInputProps {
  name: string;
  id: string;
  value: string;
  entity: any;
  disabled: boolean;
  isValid: boolean;
  setValue: (value: string) => void;
  getValue: () => string;
  onChange: (name: string, value: any) => void;
}

function RestaurantNumberInput(props: RestaurantNumberInputProps) {
  const [isLicenseChecked, setIsLicenseChecked] = useState(false);
  // eslint-disable-next-line consistent-return
  const checkAlcoholLicense = async (restaurantNumberInput: string) => {
    try {
      const response = await datalayer.alcoholLicense.list({
        query: {
          restaurantNumber: restaurantNumberInput,
          or: [
            { organizationNumber: props.entity.organisationNumber },
            { organizationNumber: 'Enskild firma' },
          ],
        },
      });

      const active = await _.get(response, 'rows[0].active', false);

      return active;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error checking alcohol license:', error);
    }
  };

  // Input field only accepts numeric values. [0-9]
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const char = event.key;

    if (!/^\d$/.test(char)) {
      event.preventDefault();
    }
  };

  const handleInputChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { name, onChange, setValue } = props;
    const value = event?.target?.value;

    setValue(value);
    await onChange(name, value || null);
    setIsLicenseChecked(false);
    if (value.length === 8) {
      const hasAlcoholPermit = await checkAlcoholLicense(value);
      setIsLicenseChecked(true);
      onChange('hasAlcoholPermit', hasAlcoholPermit);
    } else {
      onChange('hasAlcoholPermit', false);
    }
  };

  return (
    <div>
      <Input
        id={props.id}
        name={props.name}
        value={props.value}
        onChange={handleInputChange}
        onKeyPress={handleKeyPress}
        disabled={props.disabled}
        maxLength={8}
        invalid={!props.isValid}
      />
      <Row>
        {isLicenseChecked && (
          <Row>
            <Col>
              {isLicenseChecked && props.entity.hasAlcoholPermit
                ? 'Har serveringstillstånd'
                : 'Saknar serveringstillstånd'}{' '}
              {isLicenseChecked && props.entity.hasAlcoholPermit && (
                <FontAwesomeIcon
                  icon={faSquareCheck}
                  size="lg"
                  color="#198754"
                />
              )}
            </Col>
          </Row>
        )}
      </Row>
    </div>
  );
}

export default withFormsyValidations(RestaurantNumberInput, () => ({
  noWierdos(values: object, value: string) {
    if (!value) return true;
    // eslint-disable-next-line
    return /^\d+$/.test(value);
  },
  length(values: object, value: string) {
    if (!value) return true;
    return value.length === 8;
  },
}));
